// extracted by mini-css-extract-plugin
export default {"cont":"BotScript_cont__IvKvD","buttonCont":"BotScript_buttonCont__AAAug"};